import React from 'react';
import PropTypes from 'prop-types';

export default class Demo extends React.Component {
  render() {
    return <div>Demo</div>;
  }
}

Demo.propTypes = {
  /**
   * optionalArray 属性
   */
  optionalArray: PropTypes.array,
  /**
   * optionalBool 属性
   */
  optionalBool: PropTypes.bool,
  /**
   * optionalFunc 属性
   */
  optionalFunc: PropTypes.func,
  /**
   * optionalNumber 属性
   */
  optionalNumber: PropTypes.number,
  /**
   * optionalObject 属性
   */
  optionalObject: PropTypes.object,
  /**
   * optionalString 属性
   */
  optionalString: PropTypes.string,
  /**
   * optionalSymbol 属性
   */
  optionalSymbol: PropTypes.symbol,
  /**
   * optionalNode 属性
   */
  optionalNode: PropTypes.node,
  /**
   * optionalElement 属性
   */
  optionalElement: PropTypes.element,
  /**
   * optionalElementType 属性
   */
  optionalElementType: PropTypes.elementType,
  /**
   * optionalEnum 属性
   */
  optionalEnum: PropTypes.oneOf(['News', 'Photos']),

  /**
   * optionalArrayOf 属性
   */
  optionalArrayOf: PropTypes.arrayOf(PropTypes.number),

  /**
   * optionalObjectOf 属性
   */
  optionalObjectOf: PropTypes.objectOf(PropTypes.number),

  /**
   * optionalObjectWithShape 属性
   */
  optionalObjectWithShape: PropTypes.shape({
    optionalProperty: PropTypes.string,
    requiredProperty: PropTypes.number.isRequired
  }),
  /**
   * requiredFunc 属性
   */
  requiredFunc: PropTypes.func.isRequired,

  /**
   * requiredAny 属性
   */
  requiredAny: PropTypes.any.isRequired,

  /**
   * customProp 属性
   */
  customProp: function(props, propName, componentName) {
    if (!/matchme/.test(props[propName])) {
      return new Error(
        'Invalid prop `' +
          propName +
          '` supplied to' +
          ' `' +
          componentName +
          '`. Validation failed.'
      );
    }
  },
};

Demo.defaultProps = {
  optionalArray: [1, 2],
  optionalBool: true
};
